import { useEffect, useState, useMemo } from 'react';
import imgDocpettern from '../images/shape-5.svg';
import getPageContent from '../api/PageContentService';

export default function WhoWeAre() {
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);

    const MEDIA_URL = process.env.REACT_APP_MEDIA_SERVER;

    useEffect(() => {
        getPageContent('quienes-somos', setError)
            .then((res) => setData(res || null))
            .catch(() => setError('Unable to load page content.'));
    }, []);

    /* --------------------------------------------------
       🔑 ALL HOOKS MUST BE ABOVE RETURNS
    -------------------------------------------------- */
    const fieldsByKey = useMemo(() => {
        if (!data?.fields) return {};
        const obj = {};
        data.fields.forEach((field) => {
            obj[field.uniqueyKey] = field;
        });
        return obj;
    }, [data]);

    /* --------------------------------------------------
       IMAGE DATA
    -------------------------------------------------- */
    const imageData = fieldsByKey['ImageData']?.fieldValue || '';
    const imageParts = imageData.split('\n').filter(Boolean);
    const imageDescription = imageParts.slice(0, -1).join('\n');
    const imageFooter = imageParts[imageParts.length - 1] || '';

    const dynamicImage = data?.image ? `${MEDIA_URL}/${data.image}` : '';

    /* --------------------------------------------------
       STATS
    -------------------------------------------------- */
    const statsKeys = ['Fundado', 'Empleados', 'Doctores', 'Usuarios Beta'];

    const stats = statsKeys.map((key) => ({
        label: fieldsByKey[key]?.fieldName || key,
        value: fieldsByKey[key]?.fieldValue || ''
    }));

    /* --------------------------------------------------
       FOUR BOX VALUES
    -------------------------------------------------- */
    const excludedKeys = [
        'Nuestra Misión:',
        'Nuestra Visión:',
        'Fundado',
        'Empleados',
        'Doctores',
        'Usuarios Beta',
        'ImageData'
    ];

    const fourBoxFields = (data?.fields || []).filter((f) => !excludedKeys.includes(f.uniqueyKey));

    /* --------------------------------------------------
       ✅ SAFE RETURNS (AFTER HOOKS)
    -------------------------------------------------- */
    if (error) {
        return <p className="p-5 text-center text-red-500">{error}</p>;
    }

    if (!data) {
        return <p className="p-5 text-center">Loading...</p>;
    }

    return (
        <div className="who-we-are pt-20">
            <div className="wrapper-box">
                <div className="lg:px-8 lg:grid lg:grid-cols-2 lg:gap-24">
                    {/* LEFT IMAGE */}
                    <div className="relative who-we-are-L">
                        <figure className="shape-6">
                            <img src={imgDocpettern} alt="" />
                        </figure>

                        <div className="relative pt-64 pb-10 bg-blue-gredient">
                            {dynamicImage && (
                                <img
                                    className="absolute inset-0 h-full w-full object-cover mix-blend-multiply"
                                    src={dynamicImage}
                                    alt="Who We Are"
                                />
                            )}

                            <div className="relative px-8">
                                <blockquote className="mt-8 text-white">
                                    <p className="who-we-are-sub-title whitespace-pre-line">{imageDescription}</p>
                                    {imageFooter && <footer className="mt-4 footer-text-who">{imageFooter}</footer>}
                                </blockquote>
                            </div>
                        </div>
                    </div>

                    {/* RIGHT CONTENT */}
                    <div className="who-we-are-R">
                        <div className="pb-8">
                            <h2 className="who-we-are-title primary-color">
                                {fieldsByKey['Nuestra Misión:']?.fieldName}
                            </h2>
                            <p className="who-we-are-sub-title">{fieldsByKey['Nuestra Misión:']?.fieldValue}</p>
                        </div>

                        <h2 className="who-we-are-title primary-color">{fieldsByKey['Nuestra Visión:']?.fieldName}</h2>
                        <p className="who-we-are-sub-title">{fieldsByKey['Nuestra Visión:']?.fieldValue}</p>

                        {/* STATS */}
                        <div className="mt-8 employee-info">
                            <dl className="grid grid-cols-2 gap-x-4 gap-y-8">
                                {stats.map((stat) => (
                                    <div key={stat.label} className="border-t-2 pt-6 employee-info-box">
                                        <dt className="employee-info-dt">{stat.label}</dt>
                                        <dd className="employee-info-dd">{stat.value}</dd>
                                    </div>
                                ))}
                            </dl>
                        </div>
                    </div>
                </div>

                {/* FOUR BOX */}
                <div className="who-we-are-four-box pt-20 pb-60">
                    <div className="wrapper-box who-we-are-four-box-wrapper">
                        <div className="grid grid-cols-2 gap-x-4 gap-y-8">
                            {fourBoxFields.map((item) => (
                                <div key={item.uniqueyKey} className="who-we-are-four-box-inner">
                                    <h5>{item.fieldName}</h5>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
